import moment from 'moment'

export default class Immunization {
  constructor (id, date, medicineCode, medicalStaffId, observations, protocolInfo, type, adverseReactionId) {
    this._id = id
    this._date = date
    this._medicalStaffId = medicalStaffId
    this._observations = observations
    this._protocolInfo = protocolInfo
    this._medicineCode = medicineCode
    this._type = type
    this._adverseReactionId = adverseReactionId
  }

  get id () {
    return this._id
  }

  get date () {
    return this._date
  }

  get medicineCode () {
    return this._medicineCode
  }

  get medicalStaffId () {
    return this._medicalStaffId
  }

  get observations () {
    return this._observations
  }

  get protocolInfo () {
    return this._protocolInfo
  }

  get type () {
    return this._type
  }

  get adverseReactionId () {
    return this._adverseReactionId
  }

  getFormattedDate (locale = 'pt-PT') {
    return moment(new Date(this._date)).format('L')
  }
}
